const BASE_THEME = {
  spacing: 4,
};

export default BASE_THEME;
